/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CallMonitoringModel { 
    status?: string;
    category?: string;
    outcome?: string;
    clientSentiment?: string;
    escalation?: boolean;
    converted?: boolean;
    followUpNeeded?: boolean;
    followUpAction?: string;
    operatorScore?: number;
    callcenterRating?: number;
    flags?: Array<string>;
    promptVersion?: string;
    greeting?: boolean;
    polite?: boolean;
    scriptAdherence?: boolean;
    farewell?: boolean;
    offeredUpsell?: boolean;
    infoCorrect?: boolean;
    productsMentioned?: Array<string>;
    city?: string;
    address?: string;
    orderNumber?: string;
    amount?: string;
    summary?: string;
}

